<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  components: {},
  created() {},
  name: "App",
};
</script>
<style>
.v-toolbar__extension {
  background: #3c9bf9 !important;
}
</style>
